import E3Fetch, { E3DelegateFetch } from "e3-common/apis/E3Fetch";
import useLoadingIndicator from "e3-common/hooks/useLoadingIndicator";
import {getLocalStorageItem, getSessionStorageItem} from "e3-common/utils/localStorageUtil";
import { LOCAL_STORAGE_KEYS } from "e3-common/constants/enumerates";
import { completeServerUrl, parseDotnetAPIUrl } from "e3-common/utils/urlUtil";
import E3Fetch4Dotnet from "e3-common/apis/E3Fetch4Dotnet";
//import { e3 } from '../components/Utils/Utils';
import "react-toastify/dist/ReactToastify.css";
import { useRef } from "react";
import { isEmpty } from "lodash";

import useMessageBox from "e3-common/hooks/useMessageBox";
import { EventSourcePolyfill } from "event-source-polyfill";
import { useToast } from "e3-common/hooks/useToast";
export default function useFetch() {
  const { confirm, alert, error } = useMessageBox();
  const { showLoading, hideLoading } = useLoadingIndicator();
  const { Loading, FinishLoading, CloseToast, Error } = useToast();

  const backendType = import.meta.env.VITE_BACKEND_TYPE; // JAVA or DOTNET
  const API_SERVER_URL = completeServerUrl(import.meta.env.VITE_API_SERVER_URL) + "/api";

  const defaultMessageOptions = {
    showConfirm: false,
    showLoad: true,
    confirmMessage: "진행하시겠습니까?",
    showSuccess: false,
    showAlert: true,
    alertTitle: "",
  };

  const _callRequest = async (url, options, messageOptions) => {
    let hasError = false;
    if (messageOptions.showLoad && messageOptions.showLoad === true) Loading();
    try {
      let response;
      if (backendType === "DOTNET") {
        let endpoint = "";
        if (url === "/login") endpoint = "Login";
        if (url === "/user/authentication") endpoint = "Authentication";
        if (url === "/menuLog") endpoint = "MenuLog";
        if (url.indexOf("file-") > 0) endpoint = url;

        // url 패턴은 /"시스템구분"/"프로그램ID"/"메소드명" 으로 되어야 함
        let programId, methodName;
        if (!endpoint) {
          let parsedUrl = parseDotnetAPIUrl(url);
          programId = parsedUrl.programId;
          methodName = parsedUrl.methodName;
          if (programId && methodName) {
            endpoint = "Execute";
          }
        }

        if (!endpoint) {
          throw new Error(".NET API 호출을 위한 필수파라미터가 잘못되었습니다.");
        }

        response = await E3Fetch4Dotnet.request({
          programId: programId || "",
          methodName: methodName || "",
          options: options || {},
          endpoint: endpoint,
        });
      }

      if (backendType === "JAVA") {
        if (!isEmpty(url)) {
          response = await E3Fetch.request(url, options);
        } else {
          // console.log("options=", options);
          response = await E3DelegateFetch.tran(options);
        }
      }

      if (messageOptions.showSuccess) {
        alert("완료", response?.responseText);
      }
      if (
        response &&
        Array.isArray(response) &&
        (response.length < 1 ||
          (response.length === 1 && typeof response[0] === "object" && Object.keys(response[0]).length === 0)) &&
        (messageOptions.showLoad ?? true)
      ) {
        FinishLoading();
      } else if (!response && (messageOptions.showLoad ?? true)) {
        FinishLoading();
      } else {
        if (messageOptions.showLoad ?? true) {
          FinishLoading();
        }
      }
      // FinishLoading();
      return response;
    } catch (e) {
      if (e.name !== "multiValidation" && messageOptions.showAlert) {
        error(messageOptions.alertTitle ?? "오류", e.message);
        hasError = true;
        CloseToast();
        return;
      }
      throw e;
    }
    // finally {
    //   if (!hasError && (messageOptions.showLoad ?? true)) {
    //     FinishLoading();
    //   }
    //   else CloseToast();
    // }
  };

  const ocrRequest = async (options) => {
    let messageOptions = {
      showConfirm: true,
      confirmMessage: "저장하시겠습니까?",
      showSuccess: true,
      showAlert: true,
      alertTitle: "저장 실패",
    };
    messageOptions = { ...defaultMessageOptions, ...messageOptions };
    showLoading();
    try {
      const baseUrl = completeServerUrl(import.meta.env.VITE_API_SERVER_URL) + "/api";
      if (messageOptions.showConfirm) {
        const confirmResult = await confirm("확인", messageOptions.confirmMessage);
        if (confirmResult) {
          const accessToken = getSessionStorageItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
          const formData = new FormData();
          for (let file of options.attachFiles) {
            formData.append("file", file);
          }
          let res = await fetch(baseUrl + "/ocr/file-upload", {
            headers: { Authorization: `Bearer ${accessToken}` },
            method: "POST",
            body: formData,
          });
          const result = await res.json();

          if (result.responseCode == "0000") {
            //일단 첫번째꺼만 들어온다 추후 배열 뷰 개발 예정
            const ATTACH_SEQ = result.data.ATTACH_SEQ[0];
            return ATTACH_SEQ;
          } else {
            if (messageOptions.showAlert) {
              error(messageOptions.alertTitle ?? "오류");
            }
          }
        }
      }
    } catch (e) {
      if (messageOptions.showAlert) {
        error(messageOptions.alertTitle ?? "오류", e.message);
      }
      return null;
    } finally {
      hideLoading();
    }
  };

  const request = async (url, options = {}, messageOptions) => {
    messageOptions = { ...defaultMessageOptions, ...messageOptions };
    try {
      if (messageOptions.showConfirm) {
        const confirmResult = await confirm("확인", messageOptions.confirmMessage);
        if (confirmResult) {
          const response = await _callRequest(url, options, messageOptions);
          return response;
        }
      } else {
        const response = await _callRequest(url, options, messageOptions);
        return response;
      }
    } catch (e) {
      await Error(e.message);
      throw e;
    }
  };

  const saveRequest = async (url, options, messageOptions, showConMessage = true) => {
    console.log("url:  ", url, " ,  options:  ", options, "  , messageOptions: ", messageOptions);
    return await request(url, options, {
      showConfirm: showConMessage,
      confirmMessage: "저장하시겠습니까?",
      showSuccess: false,
      showAlert: true,
      alertTitle: "저장 실패",
      reqType: "SAVE",
      ...messageOptions,
    });
  };

  const deleteRequest = async (url, options, messageOptions) => {
    return await request(url, options, {
      showConfirm: true,
      confirmMessage: "삭제하시겠습니까?",
      showSuccess: false,
      showAlert: false,
      alertTitle: "삭제 실패",
      reqType: "DEL",
      ...messageOptions,
    });
  };

  const downloadFile = async (attachFileSeq, saveInDB = false) => {
    const param = {
      ATTACH_FILE_SEQ: attachFileSeq,
      SAVE_IN_DB: saveInDB,
    };

    if (backendType === "DOTNET") {
      const endpoint = "/file-info";
      const options = {
        method: "POST",
        body: param,
      };

      let response = await E3Fetch4Dotnet.request({
        programId: "",
        methodName: "",
        options: options || {},
        endpoint: endpoint,
      });

      if (response) {
        const filename = response[0]?.SAVE_FILE_NM;

        if (filename) {
          const downloadFilename = filename;
          const url = `${import.meta.env.VITE_API_SERVER_FILE_URL}/Download/${encodeURI(downloadFilename)}`;
          let a = document.createElement("a");
          a.href = url;
          a.click();
        }
      }
    } else if (backendType === "JAVA") {
      const response = await request("/saveDownloadToken", {
        body: param,
      });

      const db = response.SAVE_IN_DB === "false" ? "0" : "1";
      var fileUrl =
        completeServerUrl(import.meta.env.VITE_API_SERVER_URL) +
        `/api/file-download/${encodeURIComponent(response.DOWNLOAD_TOKEN)}?db=${db}`; // 파일 다운로드를 처리하는 서버의 엔드포인트로 변경해야 합니다.
      let a = document.createElement("a");
      a.href = fileUrl;
      a.click();
      // if (response) {
      //   const linkSource = `data:${response.FILE_TYPE};base64,${response.FILE_CONTENT}`;
      //   let a = document.createElement('a');
      //   //a.href = response.FILE_CONTENT;
      //   a.href = linkSource;
      //   a.download = response.FILE_NAME;
      //   a.click();
      // }
    }
  };

  const downloadFileBase64 = async (attachFileSeq, saveInDB = false) => {
    const param = {
      ATTACH_FILE_SEQ: attachFileSeq,
      SAVE_IN_DB: saveInDB,
    };
    const response = await request("/saveDownloadToken", {
      body: param,
    });

    const db = response.SAVE_IN_DB === "false" ? "0" : "1";

    const fileResponse = await request("/file-download-base64", {
      body: { downloadToken: response.DOWNLOAD_TOKEN, db: db },
    });
    return fileResponse;
  };

  const partialDownloadFile = async (attachFileSeq, saveInDB = false) => {
    const param = {
      ATTACH_FILE_SEQ: attachFileSeq,
      SAVE_IN_DB: saveInDB,
    };
    const response = await request("/saveDownloadToken", {
      body: param,
    });

    return request(`/file-partial-download/${encodeURIComponent(response.DOWNLOAD_TOKEN)}`, {
      method: "GET",
      fileToken: "insighton.co.kr",
    });
  };

  const subscribeToSSE = async (url, clientId) => {
    const accessToken = getSessionStorageItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);

    // const eventSource = await E3Fetch.request(url, {
    //   method:"POST",
    //   body: {clientId: clientId}
    // });

    const eventSource = new request(API_SERVER_URL + url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: { clientId: clientId },
    });

    eventSource.addEventListener("EVN_INIT", (event) => {
      console.log("초기설정 메시지:", event.data);
    });

    eventSource.addEventListener("message", (event) => {
      console.log("서버 측 메시지:", event.data);
    });

    eventSource.onerror = (error) => {
      console.error("SSE 에러:", error);
      eventSource.close();
    };

    return eventSource;
  };

  return {
    ocrRequest,
    _callRequest,
    request,
    saveRequest,
    deleteRequest,
    downloadFile,
    downloadFileBase64,
    partialDownloadFile,
    subscribeToSSE,
  };
}
